import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { TransactionBaseDto } from "../dto/transactions/transaction-base.dto";

const c = initContract();

export interface ManualTransactionsCreationResponse {
    transactions: TransactionBaseDto[];
}

export const manualTransactionContract = c.router(
    {
        createManualTransactions: {
            method: "POST",
            path: "",
            body: z
                .object({
                    financialAccountId: z.number().optional(),
                    createCashAccount: z.boolean().optional(),
                    entityId: z.number(),
                    transactions: z.array(
                        z.object({
                            categoryId: z.string().uuid(),
                            amount: z.number(),
                            date: z.coerce.date(),
                            memo: z.string().optional().nullable(),
                        }),
                    ),
                })
                .refine(
                    (data) => {
                        const { financialAccountId, createCashAccount } = data;

                        // case when financialAccountId is defined
                        if (
                            financialAccountId &&
                            financialAccountId > 0 &&
                            !createCashAccount
                        ) {
                            return true;
                        }

                        // case when createCashAccount
                        if (createCashAccount && !financialAccountId) {
                            return true;
                        }

                        return false;
                    },
                    {
                        message:
                            "Exactly one of financialAccountId or createCashAccount must be defined.",
                        path: ["financialAccountId"],
                    },
                ),
            responses: {
                200: c.type<ManualTransactionsCreationResponse>(),
                400: c.type<{ message: string }>(),
            },
        },
    },
    {
        pathPrefix: "/manual-transaction",
    },
);
